import { Backdrop, CircularProgress } from "@mui/material";

export default function PageLoadingSpinner() {
  return (
    <Backdrop sx={{ backgroundColor: "rgba(0, 0, 0, 0.8)", zIndex: 100 }} open={true}>
      <CircularProgress color="success" />
    </Backdrop>
  );
}
